import { GlobalVariableNames } from "./description";
import { SerializedComponent, SerializedComponentsObject } from "../components/SerializedApp";
import { LetBinding, RowIndexOrRowID } from "./serialized-component";
import { ComponentBuilder } from "./components";
import { rowIndexColumnName } from "../google-sheets";

export function makeUserProfileArgsForCommentsAndChat(
    builder: ComponentBuilder
): { lets: readonly LetBinding[]; args: SerializedComponentsObject } {
    const userProfile = builder.makeUserProfileRow();
    if (userProfile === undefined) {
        return { lets: [], args: {} };
    }

    const { b } = builder;

    let lets: readonly LetBinding[] | undefined;
    let args: SerializedComponentsObject = {};

    const userProfiles = b.lookupFunction("allUserProfileProperties");
    if (userProfiles !== undefined) {
        args = { ...args, userProfiles };
    }

    if (userProfile !== undefined) {
        lets = [["userProfile", userProfile.row]];

        const nameColumnName = b.lookupGlobalVariable(GlobalVariableNames.UserProfileNameColumnName);
        const nameProperty = b.getDynamicProperty(nameColumnName, b.getVariable("userProfile"));
        const emailColumnName = b.lookupGlobalVariable(GlobalVariableNames.UserProfileEmailColumnName);
        const rowIndexOrRowID: RowIndexOrRowID<SerializedComponent> = {
            keyColumnName: emailColumnName,
            keyColumnValue: b.getDynamicProperty(emailColumnName, b.getVariable("userProfile")),
            rowIndex: b.getProperty(rowIndexColumnName, b.getVariable("userProfile"), userProfile.table),
        };

        const setColumnsData = b.setColumnInRowForProperty(
            nameColumnName,
            nameProperty,
            b.lookupGlobalVariable(GlobalVariableNames.UserProfileTableName),
            rowIndexOrRowID,
            false
        );

        args = {
            ...args,
            userName: nameProperty,
            onSetUserName: setColumnsData.action,
            isSetUserNameEnabled: setColumnsData.isEnabled,
        };
    }

    return { lets: lets ?? [], args };
}
